'use strict';

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _excluded = ["checked", "disabled", "indeterminate", "tabIndex", "theme", "variant"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('./extends-214be52a.js');

var defineProperty = require('./defineProperty-754b29ce.js');

var _styled = require('styled-components');

var React = require('react');

var index = require('./index-6b8189f0.js');

var reactSpringWeb_esm = require('./react-spring-web.esm-b5843e07.js');

var FocusVisible = require('./FocusVisible.js');

var springs = require('./springs.js');

var Theme = require('./Theme.js');

var constants = require('./constants.js');

var miscellaneous = require('./miscellaneous.js');

require('./_commonjsHelpers-b3309d7b.js');

require('react-dom');

require('./theme-dark.js');

require('./theme-light.js');

require('./environment.js');

require('./color.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SIZE = 18;
var CHECKBOX_RADIUS = 2;
var RADIO_BULLET_SIZE = 10;

var Checkbox = /*#__PURE__*/function (_React__default$defau) {
  _inherits(Checkbox, _React__default$defau);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.apply(this, arguments);

    defineProperty._defineProperty(_assertThisInitialized(_this), "_element", /*#__PURE__*/React__default["default"].createRef());

    defineProperty._defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate;
      onChange(indeterminate ? false : !checked);
    });

    defineProperty._defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this._element.current.focus();
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "getAriaChecked",
    value: function getAriaChecked() {
      var _this$props2 = this.props,
          checked = _this$props2.checked,
          indeterminate = _this$props2.indeterminate;
      if (indeterminate) return 'mixed';
      if (checked) return 'true';
      return 'false';
    }
  }, {
    key: "renderCheck",
    value: function renderCheck(visible, Icon) {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          theme = _this$props3.theme;
      return /*#__PURE__*/React__default["default"].createElement(reactSpringWeb_esm.Spring, {
        from: {
          progress: 0
        },
        to: {
          progress: Number(visible)
        },
        config: springs.springs.instant,
        native: true
      }, function (_ref) {
        var progress = _ref.progress;
        return /*#__PURE__*/React__default["default"].createElement(_StyledAnimatedSpan, {
          style: {
            opacity: progress,
            transform: progress.to(function (v) {
              return "scale(".concat(v, ")");
            })
          }
        }, /*#__PURE__*/React__default["default"].createElement(Icon, {
          color: disabled ? theme.selectedDisabled : theme.selected
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          checked = _this$props4.checked,
          disabled = _this$props4.disabled,
          indeterminate = _this$props4.indeterminate,
          tabIndex = _this$props4.tabIndex,
          theme = _this$props4.theme,
          variant = _this$props4.variant,
          props = _objectWithoutProperties(_this$props4, _excluded);

      return /*#__PURE__*/React__default["default"].createElement(FocusVisible["default"], null, function (_ref2) {
        var focusVisible = _ref2.focusVisible,
            onFocus = _ref2.onFocus;
        return /*#__PURE__*/React__default["default"].createElement(_StyledButton, _extends._extends({
          type: "button",
          ref: _this2._element,
          role: variant,
          tabIndex: tabIndex,
          "aria-checked": _this2.getAriaChecked(),
          onClick: _this2.handleClick,
          onFocus: onFocus,
          disabled: disabled
        }, props, {
          $_css: 0.5 * constants.GU,
          $_css2: disabled ? theme.controlDisabled : theme.control,
          $_css3: theme.controlBorder,
          $_css4: variant === 'radio' ? '50%' : "".concat(CHECKBOX_RADIUS, "px"),
          $_css5: !disabled ? "\n                    cursor: pointer;\n                    &:active {\n                      border-color: ".concat(theme.controlBorderPressed, ";\n                    }\n                    &:focus .focus-ring {\n                      display: ").concat(focusVisible ? 'block' : 'none', ";\n                    }\n                  ") : ''
        }), variant === 'checkbox' && _this2.renderCheck(checked && !indeterminate, Check), variant === 'checkbox' && _this2.renderCheck(indeterminate, Dash), variant === 'radio' && _this2.renderCheck(checked, Bullet), /*#__PURE__*/React__default["default"].createElement(_StyledSpan, {
          className: "focus-ring",
          $_css6: theme.focus,
          $_css7: variant === 'radio' ? '50%' : "".concat(constants.RADIUS, "px")
        }));
      });
    }
  }]);

  return Checkbox;
}(React__default["default"].PureComponent);
/* eslint-disable react/prop-types */


defineProperty._defineProperty(Checkbox, "propTypes", {
  checked: index.PropTypes.bool,
  disabled: index.PropTypes.bool,
  indeterminate: index.PropTypes.bool,
  onChange: index.PropTypes.func,
  tabIndex: index.PropTypes.string,
  theme: index.PropTypes.object,
  variant: index.PropTypes.oneOf(['checkbox', 'radio'])
});

defineProperty._defineProperty(Checkbox, "defaultProps", {
  checked: false,
  disabled: false,
  indeterminate: false,
  onChange: miscellaneous.noop,
  tabIndex: '0',
  variant: 'checkbox'
});

var Dash = function Dash(_ref3) {
  var color = _ref3.color;
  return (
    /*#__PURE__*/

    /* Use SVG to have subpixels (strokeWidth="1.5") on Chrome */
    React__default["default"].createElement("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, /*#__PURE__*/React__default["default"].createElement("line", {
      x1: "3",
      y1: "7",
      x2: "11",
      y2: "7",
      stroke: color,
      strokeWidth: "1.5"
    }))
  );
};

var Check = function Check(_ref4) {
  var color = _ref4.color;
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "12",
    height: "8",
    viewBox: "0 0 12 8"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "\n        M11.059 1.393\n        L4.335  7.395\n        L0.944  3.260\n        L2.104  2.309\n        L4.503  5.234\n        L10.060 0.274\n        L11.059 1.393\n        Z\n      ",
    fill: color
  }));
};

var Bullet = function Bullet(_ref5) {
  var color = _ref5.color;
  return /*#__PURE__*/React__default["default"].createElement(_StyledSpan2, {
    $_css8: color
  });
};

var CheckBoxWithTheme = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
  var theme = Theme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(Checkbox, _extends._extends({
    theme: theme,
    ref: ref
  }, props));
});

var _StyledAnimatedSpan = _styled__default["default"](reactSpringWeb_esm.animated.span).withConfig({
  displayName: "Checkbox___StyledAnimatedSpan",
  componentId: "sc-1v41gs7-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;transform-origin:50% 50%;"]);

var _StyledButton = _styled__default["default"]("button").withConfig({
  displayName: "Checkbox___StyledButton",
  componentId: "sc-1v41gs7-1"
})(["display:inline-flex;position:relative;width:", "px;height:", "px;margin:", "px;padding:0;background:", ";border:1px solid ", ";border-radius:", ";outline:0;&::-moz-focus-inner{border:0;}", ";"], SIZE, SIZE, function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
});

var _StyledSpan = _styled__default["default"]("span").withConfig({
  displayName: "Checkbox___StyledSpan",
  componentId: "sc-1v41gs7-2"
})(["position:absolute;top:-2px;left:-2px;right:-2px;bottom:-2px;border:2px solid ", ";border-radius:", ";display:none;"], function (p) {
  return p.$_css6;
}, function (p) {
  return p.$_css7;
});

var _StyledSpan2 = _styled__default["default"]("span").withConfig({
  displayName: "Checkbox___StyledSpan2",
  componentId: "sc-1v41gs7-3"
})(["display:block;width:", "px;height:", "px;border-radius:50%;background:", ";"], RADIO_BULLET_SIZE, RADIO_BULLET_SIZE, function (p) {
  return p.$_css8;
});

exports["default"] = CheckBoxWithTheme;